module.exports = __webpack_public_path__ + "static/media/badge.c6b8b9d2.svg";